import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const HEADLINE = 'The answer is usually in the chart. Someone has to read it.';

const Home = () => {
  useEffect(() => {
    document.title = 'Afterimage Labs';
  }, []);

  return (
    <main>
      <section className="ai-hero">
        <div className="ai-wrap">
          <h1>
            <span className="ghost" aria-hidden="true">{HEADLINE}</span>
            <span className="real">{HEADLINE}</span>
          </h1>
          <p className="lede">
            When a diagnosis is missed or delayed, the warning signs are often
            already in the medical record: a scan nobody followed up on, a lab
            value that sat for weeks. We collect the records, read every page,
            and report what the chart shows. Patients, families, attorneys and
            health systems all send us cases.
          </p>
          <div className="ai-actions">
            <Link className="ai-btn" to="/mission">Why we started</Link>
            <Link className="ai-textlink" to="/impact">How often this happens</Link>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>How often this happens</h2>
          <ul className="ai-figures">
            <li>
              <b>1 in 5</b>
              patients goes through a diagnostic error at some point in their care.
              Most are minor. Some aren't.
            </li>
            <li>
              <b>1 million+</b>
              people are permanently disabled or killed by one every year. Somewhere
              between 5,000 and 10,000 of those cases ever get investigated.
            </li>
            <li>
              <b>$300 billion+</b>
              a year in preventable costs from medical errors, paid by patients,
              families and insurers.
            </li>
          </ul>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>What we do</h2>
          <ol className="ai-steps">
            <li>
              <h3>Get the records</h3>
              <p>
                Patients have a legal right to their medical records, but hospitals
                rarely make them easy to get. We send the requests, follow up when
                they stall, and keep going until every file arrives.
              </p>
            </li>
            <li>
              <h3>Read every page</h3>
              <p>
                Our software turns thousands of pages into a timeline of what was
                seen, when, and by whom. It flags the places where a diagnosis
                could have come sooner. A person checks every flag.
              </p>
            </li>
            <li>
              <h3>Report what the chart shows</h3>
              <p>
                You get the timeline and a plain account of where the care went
                wrong, or a clear statement that it didn't. Patients use it to
                understand what happened. Attorneys use it to judge whether a case
                holds up. Hospitals use it to find the gap that keeps producing
                the same miss.
              </p>
            </li>
          </ol>
        </div>
      </section>

      <section className="ai-close">
        <div className="ai-wrap">
          <h2>Every chart deserves a careful read.</h2>
          <p>
            We get the records and say plainly what they show, whichever way
            that points.
          </p>
          <div className="ai-actions">
            <Link className="ai-btn" to="/mission">How we work</Link>
            <Link className="ai-textlink" to="/careers">Work with us</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
